import { Label, Switch } from "@libs/zapi-ui/shadcn";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { useTranslation } from "react-i18next";
import { useLabsModeToggle } from "./useLabsModeToggle";

type TSmallModeSwitchProps = { id?: string; className?: string };

export function SmallModeSwitch(props: TSmallModeSwitchProps) {
  const { id = "labs-mode", className = "" } = props;
  const { t } = useTranslation("common");
  const { available, enabled, setEnabled } = useLabsModeToggle();

  if (!available) return null;

  return (
    <div data-testid="labs-mode-container" className={`flex flex-col ${className}`}>
      <div className="flex items-center justify-between mb-2">
        <Label htmlFor={id}>
          <FigmaTypography variant="label-2">{t("labsMode.title")}</FigmaTypography>
        </Label>

        <Switch id={id} data-testid="labs-mode-switch" checked={enabled} onCheckedChange={setEnabled} />
      </div>
      <FigmaTypography variant="body-3" color="zinc600">
        {t("labsMode.menuDescription")}
      </FigmaTypography>
    </div>
  );
}
